import BaseResource from './BaseResource';

export default class PropertyPreviewResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get() {
    return super
      .get({ responseType: 'blob' })
      .then((response) => response)
      .catch((error) => error.response);
  }

  set(fileId) {
    return super
      .post({}, { url: `${this.url}/${fileId}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  remove() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }
}
